import React from "react";
import { AIShopperPanel } from "@/components/AIShopper";
import { Sparkles } from "lucide-react";

const AIShopperPage = () => {
  return (
    <div className="max-w-2xl mx-auto px-4 py-8" data-testid="ai-shopper-page">
      <div className="text-center mb-6">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#C05A3C]/10 text-[#C05A3C] text-xs font-semibold mb-3">
          <Sparkles className="w-3.5 h-3.5" /> Powered by AI
        </div>
        <h1 className="font-display text-4xl sm:text-5xl text-[#1A2024]">Your Personal Shopper</h1>
        <p className="text-muted-foreground mt-2 text-base">
          Describe what you need — a product, a service, or a whole occasion — and I'll find the best from AfriMarket.
        </p>
      </div>
      <div className="rounded-2xl border border-black/10 bg-white shadow-sm overflow-hidden">
        <div className="h-[65vh] min-h-[480px] flex flex-col">
          <AIShopperPanel embedded />
        </div>
      </div>
    </div>
  );
};

export default AIShopperPage;
